import { render, staticRenderFns } from "./QRadio.vue?vue&type=template&id=950aa8a2&scoped=true"
import script from "./QRadio.vue?vue&type=script&lang=js"
export * from "./QRadio.vue?vue&type=script&lang=js"
import style0 from "./QRadio.vue?vue&type=style&index=0&id=950aa8a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950aa8a2",
  null
  
)

/* custom blocks */
import block0 from "./QRadio.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports